export default "__VITE_ASSET__DL4rxL3h__"